const types = {
    INITIALIZE_WORK_SESSION: 'INITIALIZE_WORK_SESSION',
    INITIALIZE_SHORT_BREAK: 'INITIALIZE_SHORT_BREAK',
    INITIALIZE_LONG_BREAK: 'INITIALIZE_LONG_BREAK',
    DECREMENT_TIMER: 'DECREMENT_TIMER',
    INCREMENT_TIMER: 'INCREMENT_TIMER',
    SET_TIMER: 'SET_TIMER',
    START_SESSION: 'START_SESSION',
    PAUSE_SESSION: 'PAUSE_SESSION',
    STOP_SESSION: 'STOP_SESSION',
    COMPLETE_SESSION: 'COMPLETE_SESSION',
    SET_WORK_SESSION_DURATION: 'SET_WORK_SESSION_DURATION',
    SET_SHORT_BREAK_SESSION_DURATION: 'SET_SHORT_BREAK_SESSION_DURATION',
    SET_LONG_BREAK_SESSION_DURATION: 'SET_LONG_BREAK_SESSION_DURATION',
    SET_LONG_BREAK_THRESHOLD: 'SET_LONG_BREAK_THRESHOLD',
    DELETE_ALL_STATISTICS: 'DELETE_ALL_STATISTICS',
    RESET_TO_DEFAULT: 'RESET_TO_DEFAULT',
};


export default types;


// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js